<script lang="ts" setup>
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { VyzvaSpecificationPublicResponse } from '/@src/client-public'
import { ZoPPM } from '/@src/client-portal'
import { formatDateString, formatDateTimeString } from '/@src/utils/format'

const { t } = useI18n()

const spec = inject<VyzvaSpecificationPublicResponse>('specResponse', {})
/** Priznak, ci sa jedna o podanu ziadost. */
const stavPodana = inject<boolean>('stavPodana', false)
const subjektDetail = inject('subjektDetail', {})
const kodIrz = inject<string>('kodIrz')
const zoppmDraftDetail = inject<ZoPPM>('zoppmDraftDetail', {})
const vals = inject<any>('valuesForUpdating')
</script>

<template>
  <DisplayListGrid>
    <dt>{{ t('vyzvy.ziadatel') }}</dt>
    <dd v-if="zoppmDraftDetail.data?.ziadatel?.osoba?.osobaRef">
      {{ zoppmDraftDetail.data.ziadatel.osoba.osobaRef.menoUplne }}
    </dd>
    <dd v-else-if="vals?.ziadatel?.osoba?.osobaRef">
      {{ vals?.ziadatel?.osoba?.osobaRef.menoUplne }}
    </dd>
    <dd v-else-if="vals?.ziadatel?.subjektRef?.nazov">
      {{ vals?.ziadatel?.subjektRef?.nazov }}
    </dd>
    <dd v-else-if="zoppmDraftDetail.data?.ziadatel?.organizacia?.organizaciaRef">
      {{ zoppmDraftDetail.data.ziadatel.organizacia.organizaciaRef.nazov }}<br />
      <span>IČO: </span>
      {{ zoppmDraftDetail.data.ziadatel.organizacia.organizaciaRef.ico }}
    </dd>
    <dd v-else-if="zoppmDraftDetail.data?.ziadatel?.organizacia">
      {{ zoppmDraftDetail.data.ziadatel.organizacia.nazov }}<br />
      <span>IČO: </span>
      {{ zoppmDraftDetail.data.ziadatel.organizacia.ico }}
    </dd>

    <dd v-else>-</dd>

    <dt>{{ t('vyzvy.kodVyzvy') }}</dt>
    <dd>{{ spec.vyzvaRef.kod }}</dd>

    <dt>{{ t('vyzvy.komponent') }}</dt>
    <dd>{{ spec.opatrenie.komponentUplnyNazov }}</dd>

    <dt>{{ t('vyzvy.opatrenie') }}</dt>
    <dd>{{ spec.opatrenie.opatrenieUplnyNazov }}</dd>

    <dt>{{ t('vyzvy.vykonavatel') }}</dt>
    <dd v-if="spec.vykonavatel">
      {{ spec.vykonavatel.organRef.nazov }}<br />
      <span>IČO: </span>
      {{ spec.vykonavatel.organRef.ico }}
    </dd>
    <template
      v-for="(sprostredkovatel, index) in spec?.sprostredkovatelia"
      :key="sprostredkovatel.sprostredkovatel"
    >
      <dt>{{ t('vyzvy.sprostredkovatel') + ' č. ' + (index + 1) }}</dt>
      <dd>
        {{ sprostredkovatel.organRef.nazov }}<br />
        <span>IČO: </span>
        {{ sprostredkovatel.organRef.ico }}
      </dd>
    </template>

    <template v-if="spec.sprostredkovatel">
      <dt>{{ t('vyzvy.sprostredkovatel') }}</dt>
      <dd>
        {{ spec.sprostredkovatel.organRef.nazov }}<br />
        <span>IČO: </span>
        {{ spec.sprostredkovatel.organRef.ico }}
      </dd>
    </template>

    <dt>{{ stavPodana ? t('globalne.kodProjektu') : t('zoppm.step15.kodIrz') }}</dt>
    <dd>{{ kodIrz }}</dd>

    <template v-if="zoppmDraftDetail.meta && !stavPodana">
      <dt>{{ t('globalne.datumVytvorenia') }}</dt>
      <dd v-if="zoppmDraftDetail.meta.casVytvorenia">
        {{ formatDateString(zoppmDraftDetail.meta.casVytvorenia) }}
      </dd>
      <dd v-else>-</dd>
    </template>

    <template v-if="zoppmDraftDetail.predlozenie">
      <dt>{{ t('globalne.datumZaevidovaniaVIspo') }}</dt>
      <dd v-if="zoppmDraftDetail.predlozenie.casPrijatia">
        {{ formatDateTimeString(zoppmDraftDetail.predlozenie.casPrijatia) }}
      </dd>
      <dd v-else>-</dd>
    </template>

    <template v-if="stavPodana">
      <dt>{{ t('zoppm.step15.overenaIdentita') }}</dt>
      <dd>
        {{ zoppmDraftDetail.data?.ziadatel?.subjektRef?.overenaIdentita ? 'Áno' : 'Nie' }}
      </dd>

      <dt>{{ t('zoppm.step15.overeneData') }}</dt>
      <dd>
        {{ zoppmDraftDetail.data?.ziadatel?.subjektRef?.overeneData ? 'Áno' : 'Nie' }}
      </dd></template
    >
    <template v-else>
      <dt>{{ t('zoppm.step15.overenaIdentita') }}</dt>
      <dd>{{ subjektDetail?.overenaIdentita ? 'Áno' : 'Nie' }}</dd>

      <dt>{{ t('zoppm.step15.overeneData') }}</dt>
      <dd>{{ subjektDetail?.overeneData ? 'Áno' : 'Nie' }}</dd></template
    >
  </DisplayListGrid>
</template>

<style scoped></style>
